import React, { useState } from 'react'
import { DesignationList, getPreviousStatuses, InputBox } from '../../../components/_utils/appUtils'
import { Button, Card, Drawer, notification, Select } from 'antd'
import { useDispatch } from 'react-redux'
import { rollbackArticleFxn } from '../actions'

const UpdateStatus = (props) => {
  let { visible, onClose, article, onSubmit } = props
  let dispatch = useDispatch()
  let statusList = getPreviousStatuses(article.articleStatus)

  let [status, setStatus] = useState('')
  const updateArticleStatus = async () => {
    if (!status) {
      notification.warning({ message: 'Please choose status.' })
      return
    }
    let targetStatus = status
    let obj = {
      status: targetStatus,
      articleId: article._id
    }
    let { success, data } = await dispatch(rollbackArticleFxn(obj))
    if (success) {
      onSubmit(data)
    }
  }

  return (
    <Drawer title={`Update Status | ${article.articleNo}`}
            visible={visible}
            width={'35%'}
            onClose={onClose}>
      <Card>
        <InputBox title={'Status'} bordered={false}>
          <Select
            onChange={(e) => {
              setStatus(e)
            }}
            value={status}>
            {statusList && statusList.length
              ? statusList.map((item, key) => {
                return (
                  <option value={item.status} key={item.status}>
                    {item.status}
                  </option>
                )
              })
              : null}
          </Select>
        </InputBox>
        <Button type='primary' onClick={updateArticleStatus}>
          Submit
        </Button>
      </Card>
    </Drawer>
  )
}
export default UpdateStatus